import {
  pgTable,
  text,
  timestamp,
  uuid,
  jsonb,
  index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Status/type constants
// ---------------------------------------------------------------------------

export const COMPLIANCE_CHECK_RESULTS = ["pass", "fail", "warning"] as const;
export type ComplianceCheckResult = (typeof COMPLIANCE_CHECK_RESULTS)[number];

export const COMPLIANCE_OVERALL_RESULTS = ["pass", "fail"] as const;
export type ComplianceOverallResult = (typeof COMPLIANCE_OVERALL_RESULTS)[number];

// ---------------------------------------------------------------------------
// Campaign Compliance Checklists — Pre-launch compliance checks (F10)
// ---------------------------------------------------------------------------
// Before a campaign goes live, the compliance guardian runs checks:
// consent coverage, quiet hours, suppression overlap, 10DLC, content limits.
// Block send if any P0 check fails.

export const campaignComplianceChecklists = pgTable("campaign_compliance_checklists", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  campaignId: uuid("campaign_id").notNull(), // FK to the campaign being checked
  campaignType: text("campaign_type").notNull(), // "email" | "sms" | "whatsapp"
  checkName: text("check_name").notNull(), // "consent_coverage" | "quiet_hours" | "suppression" | "10dlc" | "content_limits"
  checkResult: text("check_result").notNull(), // ComplianceCheckResult
  details: jsonb("details").$type<Record<string, unknown>>(), // Structured check output
  overallResult: text("overall_result").notNull(), // ComplianceOverallResult
  evaluatedAt: timestamp("evaluated_at", tz).notNull().defaultNow(),
  evaluatedBy: text("evaluated_by"), // "system" or staff user ID
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_camp_compliance_tenant").on(table.tenantId),
  index("idx_camp_compliance_campaign").on(table.tenantId, table.campaignId),
]);
